module.exports = __webpack_public_path__ + "ch.svg?4abf347744438a7021ebebbcc7da720e";